// @flow
import * as React from 'react';

import { StyledButton } from './styles';

type Props = {
    alternate?: boolean,
    children: React.Node
};

/**
 * Represents a wrapper around a `button` component.
 *
 * alternate: whether or not to show a different style
 */
export default function Button({ alternate, children, ...props }: Props) {
    return (
        <StyledButton {...props} alternate={alternate}>
            {children}
        </StyledButton>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/button/buttons-button.component.js